import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  DeleteMappingElementMutationRequest,
  DeleteMappingElementMutationResponse,
} from "../types/DeleteMappingElement"

type DeleteMappingElementClient = typeof client<
  DeleteMappingElementMutationResponse,
  Error,
  DeleteMappingElementMutationRequest
>
type DeleteMappingElement = {
  data: DeleteMappingElementMutationResponse
  error: Error
  request: DeleteMappingElementMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<DeleteMappingElementClient>>
  client: {
    parameters: Partial<Parameters<DeleteMappingElementClient>[0]>
    return: Awaited<ReturnType<DeleteMappingElementClient>>
  }
}
/**
 * @link /v1/client-settings/delete-mapping-element
 */
export function useDeleteMappingElement(
  options: {
    mutation?: UseMutationOptions<
      DeleteMappingElement["response"],
      DeleteMappingElement["error"],
      DeleteMappingElement["request"]
    >
    client?: DeleteMappingElement["client"]["parameters"]
  } = {}
): UseMutationResult<
  DeleteMappingElement["response"],
  DeleteMappingElement["error"],
  DeleteMappingElement["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    DeleteMappingElement["response"],
    DeleteMappingElement["error"],
    DeleteMappingElement["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        DeleteMappingElement["data"],
        DeleteMappingElement["error"],
        DeleteMappingElement["request"]
      >({
        method: "delete",
        url: `/v1/client-settings/delete-mapping-element`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
